/* eslint-disable */
import React, { Component } from 'react';
import { ProgressBar, Container, Row, Col, Nav, Navbar} from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

import ReactGA from "react-ga";
import Wrapper from "./Wrapper";
import history from "./history";
import { createBrowserHistory } from "history";
import Poster from "./components/Poster";
import PosterInfo from "./components/PosterInfo";

import data from "./posters_data.json";
import BlankSVG from './BlankSVG';


ReactGA.initialize("UA-157191046-1");

const hist = createBrowserHistory();
const PATH = '/2020/';

hist.listen(location => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
});



class App extends Component {

    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();
        this.aboutRef = React.createRef();
        //.callRef = React.createRef();
        this.programRef = React.createRef();
        this.refNav = React.createRef();
        this.mainHeaderNav = React.createRef();
        //this.refPostponement = React.createRef();
        this.refExhibition = React.createRef();
        this.posterFullInfo = React.createRef();




        this.p5 = React.createRef();
        this.changeheaderFullInfo = this.changeheaderFullInfo.bind(this);

        this.posters = [];

        /*this.posters.push(<Col key="26" className="p-5" xs={12}/>)*/

        // available colours
        const baseColors = ["#00FFFF", "#00FF00","#FFFF00","#FF5100","#FF007C"]; // => add/remove colours
        let c = Math.floor(Math.random()*baseColors.length);
        c = baseColors[c];

        // change colour of header in responsive
        document.documentElement.style.setProperty('--responsive-header-color', c);


        this.state = {
            'open': false,
            'color': c,
            'posters': [],
            'svgImg': null,
            'loadingBar': 0
        };

        window.addEventListener('popstate', this.listener);

    }

    listener = () => {
        // update header when location changes using back()
        if (history.location.pathname.includes(PATH + 'exhibition')) {
            this.posterFullInfo.current.close();
        }
    }

    openWrapper = (e, path) => {
        e.preventDefault();
        this.wrapperRef.current.open(path);
        this.selectMenu(path);
        //postponement
    };

    changeheaderFullInfo = (open) => {
        const mainHeaderNav = this.mainHeaderNav.current;
        const nav = this.refNav.current;

        if (open) {
            nav.classList.add('color-header');
            mainHeaderNav.classList.add('color-header');
        } else {
            nav.classList.remove('color-header');
            mainHeaderNav.classList.remove('color-header');
        }
    }

    selectMenu = (path) => {
        // menuLink available
        const about = this.aboutRef.current;
        //const call = this.callRef.current;
        const program = this.programRef.current;
        const nav = this.refNav.current;
        const mainHeaderNav = this.mainHeaderNav.current;
        //const postponement = this.refPostponement.current;
        // const exhibition = this.refExhibition.current;

        //call.classList.remove('active');
        about.classList.remove('active');
        program.classList.remove('active');
        // postponement.classList.remove('active');
        // exhibition.classList.remove('active');


        if (path === PATH + "/about") {
            about.classList.add('active');
            nav.classList.add('responsive-header-color');
            mainHeaderNav.classList.add('responsive-header-color');
        } else if (path === PATH + "/call-for-posters") {
            //call.classList.toggle('active');
            nav.classList.add('responsive-header-color');
            mainHeaderNav.classList.add('responsive-header-color');
        } else if (path === PATH + "/program") {
            program.classList.add('active');
            nav.classList.add('responsive-header-color');
            mainHeaderNav.classList.add('responsive-header-color');
        } else if (path === PATH + "/postponement") {
            //postponement.classList.toggle('active');
            nav.classList.add('responsive-header-color');
        } else if (path === PATH + "/exhibition") {
            //exhibition.classList.toggle('active');
            nav.classList.add('responsive-header-color');
            mainHeaderNav.classList.add('responsive-header-color');

        }
    };

    componentDidMount() {
        this.selectMenu(history.location.pathname);

        ReactGA.pageview(window.location.pathname);

        this.poster = [];
        let nPoster = 0;
        for (let i = (data.length-1); i >= 0; i--) {
            const info = data[i];
            if (info.active) {
                nPoster++;
                this.posters.push(
                    <Poster
                        key={i}
                        i={i}
                        id={"poster-" + i}
                        url={info.url}
                        author={info.author}
                        title={info.title}
                        active={info.active}
                        country={info.country}
                        fullInfoActive={info.fullInfo}
                        fullInfo={this.posterFullInfo}
                    />
                );
            }
        }

        this.setState({
            'posters': this.posters
        });


        document.onreadystatechange = () => {
            const docState = document.readyState;
            if (docState === 'interactive') {
                this.setState({'loadingBar': 0});
            } else if (docState === 'complete') {
                this.setState({'loadingBar': 100});
                //init website
                const bar = document.querySelector('.progress-bar');

                bar.ontransitionend = () => {
                    const container = document.querySelector('.themed-container');
                    container.style.opacity = 1;
                    container.style.pointerEvents = 'auto';

                    bar.style.opacity = 0;

                    container.ontransitionend = () => {
                        // if fullInfo open, scrool to poster
                        /*if (window.location.pathname.includes('exhibition')) {
                            const id = window.location.pathname.split('/')[2];
                            let posterPos = document.getElementById(`poster-poster-${id}`).offsetTop;
                            let div = document.querySelector('.expo-container');
                            console.log(parseInt(posterPos));
                            window.scrollTo(posterPos);
                            //.scrollTop(posterPos.offsetTop)
                        }*/
                    }
                };
            }

        }

        // open the wrapper when the exhibition is passed on get
        if (window.location.pathname.includes('exhibition/')) {
            const id = parseInt(window.location.pathname.split('/')[2]);

            if (isNaN(id)) {
                return;
            }

            if (id <= nPoster && id > 0) {
                this.posterFullInfo.current.open((id - 1));
            } else {
                history.push(PATH);
                return;
            }

            //const posterPos = document.getElementById(`poster-${id}`);
            //console.log(posterPos);
        } else if ((window.location.pathname.split('/').length) >= 2) {
            const path = window.location.pathname.split('/')[1];
            if (path === 'live' || path === 'stream' || path === 'livestream') {
                window.location.href= "https://www.youtube.com/watch?v=w51m6MWAAtU";
            }
        }
    }

    render () {
        return (
            <div>
                <Container className="themed-container" fluid={true}>
                    <header>
                        <Navbar ref={this.mainHeaderNav} className="main-header-outer" fixed="top">
                            <Nav className="mr-auto w-100 main-header-inner">
                                <Col xs={12} sm={9} md={9} lg={9}>
                                    <h1>
                                        <Nav.Link href={PATH} className="not-underline">
                                            <span className="not-underline">PCD@Coimbra 2020</span>
                                        </Nav.Link>
                                    </h1>
                                </Col>
                            </Nav>
                        </Navbar>
                        <Navbar ref={this.refNav} className="header-outer" fixed="bottom">
                            <Nav className="mr-auto w-100 header-inner">
                                <Col className="main-header" xs={8} sm={9} md={9} lg={6}>
                                    <Nav.Link onClick={(e) => {this.openWrapper(e, PATH + 'program')}}>
                                        <span ref={this.programRef}>Program</span>
                                    </Nav.Link>
                                    <Nav.Link onClick={(e) => {this.openWrapper(e, PATH + 'about')}}>
                                        <span ref={this.aboutRef}>About</span>
                                    </Nav.Link>
                                    {/*<Nav.Link onClick={(e) => this.openWrapper(e, '/exhibition')}>
                                        <span ref={this.refExhibition}>Exhibition</span>
                                    </Nav.Link>*/}
                                </Col>
                                <Col className="social" xs={4} sm={3} md={2} lg={6}>
                                    <Row>
                                        <Col className="social-item" sm={3} md={3} lg={6}/>
                                        <Col className="social-item" xs={3} sm={1} md={3} lg={2}>
                                            <Nav.Link href="https://www.facebook.com/pcdcoimbra">
                                                <span>fb</span>
                                            </Nav.Link>
                                        </Col>
                                        <Col className="social-item" xs={3} sm={1} md={3} lg={2}>
                                            <Nav.Link href="https://www.instagram.com/pcdcoimbra/">
                                                <span>ig</span>
                                            </Nav.Link>
                                        </Col>
                                        <Col className="social-item" xs={3} sm={1} md={3} lg={2}>
                                            <Nav.Link href="https://twitter.com/pcdcoimbra">
                                                <span>tw</span>
                                            </Nav.Link>
                                        </Col>
                                    </Row>
                                </Col>
                            </Nav>
                        </Navbar>
                    </header>
                    <main>
                        <div className="wrapper-site">
                            <Row className="border-bt colored-background  pcd-important-info">
                                <Col className="pl-5 pt-4 pr-5 pb-2">
                                    <h3> New date:<br/>9th December 2020</h3>
                                    <p>  Fully online event (
                                        <a href={PATH + "program"} onClick={(e) => {this.openWrapper(e, PATH + 'program')}}>
                                            <span>program</span>
                                        </a>)

                                   </p>
                                    {/*<p>We are live <a href="https://youtu.be/w51m6MWAAtU" target="_blank" rel="noopener noreferrer">here</a></p>*/}
                                </Col>
                            </Row>
                            <section className="expo-container main-container default pb-5 mb-5">
                                <Row className="info-expo ">
                                    <Col className="pl-5 pt-4 pr-5 pb-2">
                                        <p><b>25: Exhibition</b><br/>An international poster exhibition on the theme 25.<br/>
                                        <a href={PATH +"exhibition"} onClick={(e) => {this.openWrapper(e, PATH + 'exhibition')}}>
                                            <span>More Information</span>
                                        </a></p>
                                        {/*25 is a exhibition that display a collection of posters collected through an <a
                                            href="/call-for-posters">open call</a> and
                                            selected by a specialised jury about the theme 25. <a href="/exhibition">More
                                                information</a></p>*/}
                                    </Col>
                                </Row>
                                <Row className="expo-container pt-4 pb-5">{/*className="pl-5 pt-4 pr-5 pb-2"-->*/}
                                    {/*<Col className="poster-container-outer" id="next-poster" xs={6} s={3} md={4}>
                                        <div className='poster-container-inner-notReleased'>
                                            <h3>New poster<br/> tomorrow</h3>
                                            <PosterNotReleased />
                                        </div>
                                    </Col>*/}
                                    {this.state.posters}
                                    <Col className="closing-expo-div" xs={6} sm={6} md={{span:8, offset:0}}>
                                        <div className="closing-expo-div-outer">
                                        <BlankSVG />
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="expo-end">
                                    <div className="fluid-padding">
                                        <Col className="pb-5">
                                            <p>© 2020 </p>
                                        </Col>
                                    </div>
                                </Row>
                            </section>
                        </div>
                        <Wrapper ref={this.wrapperRef} c={this.state.color}/>
                    </main>
                    <PosterInfo changeHeaderColors={this.changeheaderFullInfo} ref={this.posterFullInfo}/>
                </Container>
                <ProgressBar now={this.state.loadingBar} />
            </div>
        );
    }
}

function PosterNotReleased (props) {
    return (
        <svg version="1.1"
             id="poster-not-released-shape" xmlns="http://www.w3.org/2000/svg"
             x="0px"
             y="0px"
             viewBox="0 0 768 1086"
             preserveAspectRatio="xMidYMid slice"
        >
            {/*<polyline className="line-rt-lb" points="768,543.14 768,1086 0,0 "/>
            <line className="line-rt-lb" x1="768" y1="1086" x2="0" y2="0"/>
            <line className="line-lt-rt" x1="0" y1="1086" x2="768" y2="0"/>*/}
            <polygon className="st0" points="264.18,347.12 351.77,769.92 503.82,739.15 416.24,316.35 	"/>
        </svg>
    );
}

export default App;